import styled from 'styled-components';
import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

export const StyledLegendColor = styled.span(props => ({
  width: '12px',
  height: '12px',
  marginRight: '8px',
  background: props['color'],
  border: '1px solid #606060',
}));

export const StyledLegendText = styled.span(props => ({
  fontSize: '12px',
  color: '#606060',
}));

export const StyledLegendRow = styled(Box)(props => ({
  display: 'flex',
  padding: '4px 0',
  alignItems: 'center',
}));

export const StyledLegendBox = styled(Box)(props => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: '3px',
  padding: '10px',
  background: 'rgba(255,255,255,.9)',
  boxShadow: '0px 0px 3px 0px rgba(96,96,96,.3)',
  cursor: 'pointer',
  [`&:hover ${StyledLegendRow}:not(:hover), &[data-selected]:not(:hover) ${StyledLegendRow}:not([data-selected])`]: {
    opacity: 0.5,
    transition: 'opacity .2s ease-in-out',
  },
}));